module.exports = __webpack_public_path__ + "img/editor_banner.17302bb.jpg";